var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbElement04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1607,
    viewBox: "0 0 1920 1607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2293.94 1189.84C948.208 1283.25 488.522 1844.72 -107.264 1304.57C-583.893 872.456 -1623.35 1011.49 -2083.5 1135.02",
    stroke: "url(#paint0_linear_1091_42714)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2296.03 1190.32C946.387 1239.38 452.861 1784.11 -108.969 1226.07C-558.433 779.636 -1605.02 884.207 -2072.13 992.296",
    stroke: "url(#paint1_linear_1091_42714)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2293.51 1188.72C942.217 1182.52 407.659 1706.22 -110.462 1126.08C-524.958 661.974 -1577.93 723.591 -2052.6 812.413",
    stroke: "url(#paint2_linear_1091_42714)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2285.86 1186.42C936.539 1132.79 368.089 1637.11 -111.202 1039.46C-494.634 561.338 -1550.44 585.919 -2030.42 657.975",
    stroke: "url(#paint3_linear_1091_42714)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2303.82 1187.42C956.763 1109.12 371.173 1602.89 -87.4439 996.656C-454.337 511.669 -1510.66 516.928 -1992.96 580.181",
    stroke: "url(#paint4_linear_1091_42714)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2306.54 1188.49C965.664 1066.14 350.298 1540.23 -70.5744 919.581C-407.272 423.063 -1462.85 393.709 -1948.56 441.097",
    stroke: "url(#paint5_linear_1091_42714)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2304.44 1186.6C975.053 1009.62 324.268 1457.8 -48.3104 820.919C-346.373 311.414 -1398.04 238.95 -1886.62 266.406",
    stroke: "url(#paint6_linear_1091_42714)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2297.45 1183.36C981.268 959.917 301.702 1384.74 -28.4757 735.513C-292.618 216.135 -1338.3 106.835 -1828.12 117.107",
    stroke: "url(#paint7_linear_1091_42714)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2284.89 1222.58C941.259 1327.65 491.035 1892.01 -113.423 1358.23C-596.99 931.201 -1633.72 1079.1 -2091.64 1206.43",
    stroke: "url(#paint8_linear_1091_42714)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2287.84 1223.27C939.11 1284.21 454.632 1833.25 -116.39 1280.21C-573.207 837.766 -1617.99 951.554 -2083.27 1063.75",
    stroke: "url(#paint9_linear_1091_42714)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2285.29 1221.69C933.999 1227.4 408.144 1755.77 -119.537 1180.24C-541.681 719.819 -1593.55 790.713 -2066.72 883.712",
    stroke: "url(#paint10_linear_1091_42714)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2277.61 1219.45C927.501 1177.71 367.436 1687.01 -121.708 1093.63C-513.023 618.921 -1568.35 652.806 -2047.1 729.087",
    stroke: "url(#paint11_linear_1091_42714)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2295.57 1220.29C947.324 1153.87 369.946 1652.77 -98.6671 1050.62C-473.558 568.902 -1529.72 583.471 -2010.93 650.97",
    stroke: "url(#paint12_linear_1091_42714)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2298.32 1221.34C955.517 1110.82 348.039 1590.3 -83.0706 973.403C-427.958 479.889 -1483.95 459.841 -1968.83 511.507",
    stroke: "url(#paint13_linear_1091_42714)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2296.18 1219.47C963.965 1054.22 320.643 1508.1 -62.445 874.554C-368.916 367.714 -1421.71 304.524 -1909.8 336.284",
    stroke: "url(#paint14_linear_1091_42714)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2289.15 1216.29C969.362 1004.46 296.875 1435.24 -44.0206 788.976C-316.737 271.964 -1364.15 171.888 -1853.76 186.477",
    stroke: "url(#paint15_linear_1091_42714)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1091_42714",
    x1: 105.219,
    y1: 1011.27,
    x2: 105.219,
    y2: 1536.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1091_42714",
    x1: 121.229,
    y1: 940.601,
    x2: 104.051,
    y2: 1464.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1091_42714",
    x1: 141.284,
    y1: 850.474,
    x2: 102.57,
    y2: 1374.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1091_42714",
    x1: 158.415,
    y1: 773.009,
    x2: 101.041,
    y2: 1296.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1091_42714",
    x1: 191.238,
    y1: 735.22,
    x2: 124.054,
    y2: 1258.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1091_42714",
    x1: 223.904,
    y1: 667.539,
    x2: 138.954,
    y2: 1190.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1091_42714",
    x1: 265.049,
    y1: 581.312,
    x2: 157.489,
    y2: 1103.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1091_42714",
    x1: 300.311,
    y1: 507.184,
    x2: 172.875,
    y2: 1028.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1091_42714",
    x1: 94.1288,
    y1: 1063.66,
    x2: 98.7462,
    y2: 1587.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1091_42714",
    x1: 109.069,
    y1: 992.729,
    x2: 96.5141,
    y2: 1516.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1091_42714",
    x1: 127.631,
    y1: 902.434,
    x2: 93.5712,
    y2: 1426.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1091_42714",
    x1: 143.481,
    y1: 824.821,
    x2: 90.8096,
    y2: 1348.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1091_42714",
    x1: 175.669,
    y1: 786.747,
    x2: 113.22,
    y2: 1310.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1091_42714",
    x1: 207.217,
    y1: 718.784,
    x2: 127.071,
    y2: 1241.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1091_42714",
    x1: 246.928,
    y1: 632.203,
    x2: 144.285,
    y2: 1154.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1091_42714",
    x1: 280.964,
    y1: 557.766,
    x2: 158.561,
    y2: 1079.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF50C",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419792,
    stopColor: "#0C33FF",
    stopOpacity: 0.580208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747917,
    stopColor: "#681C97",
    stopOpacity: 0.335417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898958,
    stopColor: "#C34444",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB1361",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbElement04);
export default __webpack_public_path__ + "static/media/ab_element_04.6a0883d96b36e7ccc92b474ac5ca9619.svg";
export { ForwardRef as ReactComponent };